import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const ShoppingBagIcon = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <svg xmlns="http://www.w3.org/2000/svg" width="20.112" height="22.516" viewBox="0 0 20.112 22.516">
        <path
          d="M21.359 18.86 20.17 7.96a2.981 2.981 0 0 0-2.964-2.663h-1.44C15.235 2.992 14.086.25 11.623.25S8.011 2.992 7.48 5.294H6.041a2.98 2.98 0 0 0-2.967 2.661L1.891 18.86a2.99 2.99 0 0 0 2.963 3.306h13.539a2.99 2.99 0 0 0 2.966-3.306zm-9.736-17.5c1.6 0 2.512 1.967 3 3.93h-6c.486-1.957 1.402-3.926 3-3.926zm8.167 19.068a1.876 1.876 0 0 1-1.392.623H4.854A1.875 1.875 0 0 1 3 18.978l1.189-10.9a1.868 1.868 0 0 1 1.852-1.669H7.26a18.777 18.777 0 0 0-.223 1.977.557.557 0 1 0 1.113.051 16.92 16.92 0 0 1 .238-2.029h6.473a17.087 17.087 0 0 1 .239 2.03.55.55 0 0 0 .568.53.558.558 0 0 0 .545-.583 18.776 18.776 0 0 0-.223-1.977h1.22a1.868 1.868 0 0 1 1.857 1.667l1.189 10.9a1.846 1.846 0 0 1-.467 1.45z"
          transform="translate(-1.569 .05)"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth=".6px"
        />
      </svg>
    </SvgIcon>
  );
});
